import { t } from '@lingui/macro';

export const DEFAULT_HEADLINE_TEXT = (): string => t`Local, loving pet care`;

export const DEFAULT_SUBLINE_TEXT = (): string =>
  t`Book trusted sitters and dog walkers who'll treat your pets like family.`;

export const ROLLOUT_COVID_ANNOUNCEMENT_FLAG = '346288f92bed2f5523ec0638a57a3f048954e50d';

export const LOCATION_INPUT_ID = 'homepage-location-input';
